const state = {
  isLoading: false,
  all: null,
};

export default state;
